module.exports = __webpack_public_path__ + "static/media/retreat.7b639d5a.svg";